import Vue from 'vue'
import wysiwyg from "vue-wysiwyg";

const options = {
  hideModules: { "headings": true, "code": true, "image": true, "table": true, "link": true, "code": true, },
  maxHeight: "200px",
  forcePlainTextOnPaste: true,
  locale: 'ru'
}

Vue.use(wysiwyg, options);
